<!--
作者：Loong
时间：2020/07/15
-->
<!-- property [ 物业缴费 ] -->
<template>

    <div id='property'>

        <div class="userSet_search" style="margin-top: 20px ;">
			<el-form :inline="true" :model="select" class="demo-form-inline" @keyup.enter.native="getData">

				<el-form-item>
					<el-button type="primary" @click="onAdd">录入</el-button>
					<el-button type="primary" @click="onDown">模板下载</el-button>
				</el-form-item>

			</el-form>
		</div>

        <el-table :data="dataset" border style="width:1675px;text-align:center;margin-bottom: 10px;font-size:12px; ">

			<el-table-column prop="community_name" label="小区名称" width="" align="center"></el-table-column>

			<el-table-column prop="year" label="年份" width="" align="center"></el-table-column>

			<el-table-column prop="" label="操作" width="" align="center">
				<template scope="scope">
                    <el-upload action="/" :before-upload="onUpload" class="upload" style="display: inline-block; margin-right: 10px">
                        <el-button type="primary" size="mini" @click="impId=scope.row.id">导入</el-button>
                    </el-upload>
					<el-button type="primary" size="mini" @click="onEdit(scope.$index,scope.row)">编辑</el-button>
					<el-button type="primary" size="mini" @click="onDetails(scope.$index,scope.row)">详情</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @current-change="page=$event; getData()" :page-size="pageSize" layout="total,prev, pager, next" :total="total"></el-pagination>

        <!-- add / edit -->
        <div class="thisfly" v-if="yearshow">
            <div class="flyBox">
                <div class="editInfoItem">
                    <ul>
                        <li>
                            <span class="editInfoItem_label">年份</span>
                            <el-input v-model="year" placeholder="请输入年份" style="width: 750px;" :maxlength="4"></el-input>
                        </li>
                    </ul>
                </div>

                <div class="editInfoItem">
                    <el-button type="primary" style="width:120px; margin-left: 330px;" @click="onAddSubmit()">提交</el-button>
                    <el-button style="width: 120px;margin-bottom: 20px; margin-left: 30px;" @click="year = ''; yearshow = false;">关闭</el-button>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
export default {
    components: { },

    props: [],

    data() {
        return{
            select: {
                year: '',        
            },

            dataset: [],
            page: 1,
            total: 0,
            pageSize: 15,

            // add / edit
            year: '',
            yearshow: false,
            yearType: 1,    // 1 新增，2 修改
            yearId: '',

            // imp
            impId: null,
        }
    },

    computed: { },

    watch: {
        route: {
            handler: function(val, old){

            },
            deep: true
        }
    },

    created(){

    },

    mounted(){
        this.loadMain();

        this.getData();
    },

    methods:{
        loadMain(){

        },

        getData(item){
            this.$jssdk.property.list({
                page: this.page
            }, (r) =>{
                this.dataset = r.data;
                this.total = r.total;
            },(err) =>{
                this.$message({
                    type:'warning',
                    message:err.data,
                    duration:2000
                })
            });
        },

        // 录入
        onAdd(){
            this.yearType = 1;
            this.yearshow = true;
        },
        onAddSubmit(){
            if(this.year == '' || this.year == null){
                this.$message({
                    type:'warning',
                    message: '请输入年份',
                    duration:2000
                })
                return;
            }
            if(this.yearType == 1){
                this.$jssdk.property.addTime({
                    year: this.year
                }, (r) =>{
                    this.year = '';
                    this.yearshow = false;
                    this.getData();
                },(err) =>{
                    this.$message({
                        type:'warning',
                        message:err.data,
                        duration:2000
                    })
                });
            } else {
                this.$jssdk.property.edit_time({
                    year: this.year,
                    id: this.yearId
                }, (r) =>{
                    this.year = '';
                    this.yearshow = false;
                    this.getData();
                },(err) =>{
                    this.$message({
                        type:'warning',
                        message:err.data,
                        duration:2000
                    })
                });
            }
        },

        // 导入
        onIn(){
            
        },

        // 上传
        onUpload(file){
            let names = file.name.split('.');
            let types = names[names.length - 1];
            if(types != 'xls'){
                this.$message({
                    type:'warning',
                    message:'上传格式错误',
                    duration:2000
                })
                return false;
            }
            let forms = new FormData();
            forms.append('tmp_name', file);
            forms.append('community_time_id', this.impId);
            this.$jssdk.property.import(forms, (r) =>{
                this.$message({
                    type:'success',
                    message: '导入成功',
                    duration:2000
                })
            },(err) =>{
                this.$message({
                    type:'warning',
                    message:err.msg,
                    duration:2000
                })
            });
            return false;
        },

        // 模板下载
        onDown(){
            this.$jssdk.property.getTempUrl({}, (r) =>{
                window.open(r.url);
            },(err) =>{
                this.$message({
                    type:'warning',
                    message:err.data,
                    duration:2000
                })
            });
        },

        // 编辑
        onEdit(index, row){
            this.yearId = row.id;
            this.year = row.year;
            this.yearType = 2;
            this.yearshow = true;
        },

        // 进入详情
        onDetails(index, row){
            this.$router.push({name: 'propertyInfoChange', query: {id: row.id}});
        },
    },
}
</script>

<style lang='less'>

</style>

<style lang='less' scoped>
    .thisfly{
        position: absolute;
		top: 0;
        left: 0;
        right: 0;
        bottom: 0;
		z-index: 6;
        background-color: rgba(0,0,0,.7);
        
        .flyBox{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 900px;
            max-height: 90%;
            border:2px solid #8fceff;
            border-radius: 10px;
            box-shadow: 5px 10px 10px rgba(51,51,51,.3);
            background-color: #ffffff;
            overflow-y: auto;

            .editInfoItem_label{
                display: inline-block;
                width: 75px;
            }

            .editInfoItem_label{
                display: inline-block;
                width: 75px;
            }
            .editInfoItem ul{
                overflow:hidden;
                list-style: none;
                padding: 0;
                margin-left: 10px;
            }
            .editInfoItem ul li{
                float: left;
                font-size: 14px;
                margin: 20px 12px  7px  7px !important;
                
            }
            .editInfoItem ul li:last-child{
                line-height: 50px;
                height: 50px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// Property.vue?77f34b98